module.exports = __webpack_public_path__ + "img/wrong.fbd2ac64.png";